(function () {
    // import rome standalone and use our moment module
    const moment  = require('moment');
    const rome = require('rome/src/rome');
    rome.use(moment);
    // CommonJS
    module.exports = rome;
}());
